type PendingToken = { token: string; accountId: string; revision: number };

/** Serializes token refreshes and invalidates in-flight work on account changes. */
export class PushTokenSync {
  private pending: PendingToken | null = null;
  private running: Promise<void> | null = null;
  private revision = 0;
  private suspended = false;

  constructor(
    private readonly send: (
      token: string,
      accountId: string,
    ) => Promise<boolean>,
  ) {}

  resume() {
    this.suspended = false;
  }
  suspend() {
    this.suspended = true;
    this.revision++;
    this.pending = null;
  }

  offer(token: string, accountId: string) {
    if (this.suspended || !token || !accountId) return Promise.resolve();
    this.pending = { token, accountId, revision: ++this.revision };
    return this.flush();
  }

  flush(): Promise<void> {
    if (this.running) return this.running;
    this.running = (async () => {
      while (this.pending && !this.suspended) {
        const item = this.pending;
        let sent = false;
        try {
          sent = await this.send(item.token, item.accountId);
        } catch {
          /* Keep for reconnect. */
        }
        if (this.pending?.revision !== item.revision) continue;
        if (!sent) return;
        this.pending = null;
      }
    })().finally(() => {
      this.running = null;
    });
    return this.running;
  }
}
